import  dayJs  from "dayjs";

export const stringToColor = (string: string) => {
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};


export const formatDate = (date: Date | undefined) => {
  if (!date) return '';
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day < 10 ? '0'+day : day }/${month < 10 ? '0'+month : month}/${year}`;
};


export const formatDateOfLastAccess = (date: string) => {
  const dateOfLastAccess = date;

  if (!dateOfLastAccess) {
    return "Nunca acessado";
  }

  const lastAccessDate = dayJs(dateOfLastAccess);

  const daysSinceLastAccess = Math.floor(
    (new Date().getTime() - lastAccessDate.valueOf()) /
      (1000 * 60 * 60 * 24)
  );

  return `há ${daysSinceLastAccess} dia(s)`;
}
